

import { useState } from "react";
import { Box, Button, } from "@mui/material";

import IndividualGiftCard from "./IndividualGiftCard";
import PartnerGiftCard from "./PartnerGiftCard";

export default function GiftCard() {
    const [activeTab, setActiveTab] = useState("Individual");
    return (
        <>
            <Box>
                <Box display="flex" justifyContent="center" gap={2} mb={2}>
                    <Button
                        variant={
                            activeTab === "Individual"
                                ? "contained"
                                : "outlined"
                        }
                        onClick={() => setActiveTab("Individual")}
                    >
                        Individual
                    </Button>
                    <Button
                        variant={
                            activeTab === "Partner" ? "contained" : "outlined"
                        }
                        onClick={() => setActiveTab("Partner")}
                    >
                        Partner
                    </Button>
                   
                </Box>

                {activeTab === "Individual" && (
                    <IndividualGiftCard />
                )}
                {activeTab === "Partner" && (
                    <PartnerGiftCard />
                )}
               
            </Box>


        </>
    );
}
